export default {
    getId(state) {
        return state.id
    }
}
